module.exports = __webpack_public_path__ + "img/lab_back.ea5e40ec.png";